// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ApplyForm — 8-chapter application wizard
   Layout: dark sidebar (left) | cream form area (right)
   ============================================================ */

.apf {
  background: var(--c-cream);
  border-top: 1px solid var(--line);
}

/* ── Outer layout ── */
.apf__layout {
  display: grid;
  grid-template-columns: clamp(200px, 22%, 280px) 1fr;
  min-height: 100vh;
}

/* ══════════════════════════════════════════════════════════════
   SIDEBAR
══════════════════════════════════════════════════════════════ */
.apf__sidebar {
  background: var(--c-forest);
  padding: clamp(1.5rem, 3vw, 2.5rem) clamp(1rem, 2.5vw, 2rem);
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
  position: sticky;
  top: 60px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  scrollbar-width: none;
}
.apf__sidebar::-webkit-scrollbar {
  display: none;
}

.apf__sidebar-heading {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.45);
  margin: 0;
}

/* Nav items */
.apf__sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}

.apf__sidebar-item {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--sp-4) 0;
  text-align: left;
  position: relative;
  transition: opacity var(--dur) var(--ease);
}
.apf__sidebar-item:not(.active):not(.done) {
  opacity: 0.45;
  cursor: default;
}
.apf__sidebar-item.active {
  opacity: 1;
}
.apf__sidebar-item.done {
  opacity: 0.75;
  cursor: pointer;
}
.apf__sidebar-item.done:hover {
  opacity: 1;
}

/* Number circle */
.apf__sidebar-num {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  border: 1.5px solid rgba(220, 204, 180, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  color: rgba(220, 204, 180, 0.55);
  flex-shrink: 0;
  transition:
    background var(--dur) var(--ease),
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.apf__sidebar-item.active .apf__sidebar-num {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}
.apf__sidebar-item.done .apf__sidebar-num {
  background: rgba(168, 102, 66, 0.25);
  border-color: var(--accent);
  color: var(--accent);
  font-size: 0.6rem;
}

.apf__sidebar-labels {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.apf__sidebar-super {
  font-family: var(--font-body);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: rgba(220, 204, 180, 0.4);
  line-height: 1;
}
.apf__sidebar-item.active .apf__sidebar-super {
  color: var(--accent);
}

.apf__sidebar-sub {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: rgba(220, 204, 180, 0.75);
  line-height: 1;
}
.apf__sidebar-item.active .apf__sidebar-sub {
  color: var(--c-sand);
  font-weight: 600;
}

/* Connector line between items */
.apf__sidebar-connector {
  position: absolute;
  left: calc(1.75rem / 2);
  top: calc(var(--sp-4) + 1.75rem);
  width: 1px;
  height: var(--sp-4);
  background: rgba(220, 204, 180, 0.15);
  transform: translateX(-50%);
}

/* Help box */
.apf__sidebar-help {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  background: rgba(168, 102, 66, 0.12);
  border: 1px solid rgba(168, 102, 66, 0.25);
  border-radius: var(--radius-sm);
  padding: var(--sp-4);
  margin-top: auto;
}

.apf__sidebar-help-icon {
  font-size: 1.1rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
}

.apf__sidebar-help-title {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--c-sand);
  margin: 0 0 0.1rem;
}
.apf__sidebar-help-sub {
  font-family: var(--font-body);
  font-size: 0.65rem;
  color: rgba(220, 204, 180, 0.5);
  margin: 0 0 0.3rem;
}
.apf__sidebar-help-link {
  font-family: var(--font-body);
  font-size: 0.65rem;
  color: var(--accent);
  text-decoration: none;
}
.apf__sidebar-help-link:hover {
  color: var(--c-sand);
}

.apf__sidebar-badge {
  display: flex;
  justify-content: center;
  padding-bottom: var(--sp-3);
}
.apf__sidebar-badge .wws__badge {
  width: 70px !important;
  height: 70px !important;
}

/* ══════════════════════════════════════════════════════════════
   MAIN FORM AREA
══════════════════════════════════════════════════════════════ */
.apf__main {
  padding: clamp(2rem, 4vw, 4rem) clamp(1.5rem, 4vw, 3.5rem);
  display: flex;
  flex-direction: column;
  gap: clamp(1.5rem, 3vw, 2.5rem);
  max-width: 860px;
}

/* Chapter meta: label + progress */
.apf__chapter-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--sp-4);
}

.apf__chapter-tag {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent);
  border: 1px solid var(--accent);
  padding: 0.3rem 0.8rem;
  border-radius: var(--radius-sm);
}

.apf__progress-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}
.apf__progress-label {
  font-family: var(--font-body);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.apf__progress-pct {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--accent);
}

.apf__progress-bar {
  width: clamp(120px, 18vw, 220px);
  height: 3px;
  background: var(--line);
  border-radius: 99px;
  overflow: hidden;
}
.apf__progress-fill {
  height: 100%;
  background: var(--accent);
  border-radius: 99px;
  transition: width 0.5s var(--ease);
}

/* Chapter heading */
.apf__chapter-head {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.apf__chapter-title {
  font-size: var(--fs-display);
  color: var(--c-forest);
  margin: 0;
}
.apf__chapter-sub {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
  max-width: 44rem;
}

/* ── Form fields ── */
.apf__chapter-body {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.apf__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-4);
}

.apf__field {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}
.apf__field--half {
  /* used inside .apf__row, no extra style needed */
}

.apf__label {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--c-ink);
}
.apf__req {
  color: var(--accent);
}

.apf__input {
  width: 100%;
  border: 1px solid rgba(27, 27, 27, 0.22);
  border-radius: var(--radius-sm);
  background: transparent;
  padding: 0.85rem 1rem;
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--c-ink);
  outline: none;
  transition:
    border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
  appearance: none;
  -webkit-appearance: none;
}
.apf__input::placeholder {
  color: rgba(27, 27, 27, 0.35);
}
.apf__input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(168, 102, 66, 0.1);
}

.apf__textarea {
  resize: vertical;
  min-height: 120px;
  line-height: var(--lh-body);
}

/* Select wrapper */
.apf__select-wrap {
  position: relative;
}
.apf__select {
  padding-right: 2.5rem;
  cursor: pointer;
  background: transparent;
}
.apf__select-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.7rem;
  color: var(--text-muted);
  pointer-events: none;
}

/* Radio group */
.apf__radios {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.apf__radio {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--c-ink);
  cursor: pointer;
}
.apf__radio input[type="radio"] {
  display: none;
}
.apf__radio-mark {
  width: 1.1rem;
  height: 1.1rem;
  border: 1.5px solid var(--line);
  border-radius: 50%;
  flex-shrink: 0;
  transition:
    border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
  position: relative;
}
.apf__radio--active .apf__radio-mark {
  border-color: var(--accent);
  background: var(--accent);
  box-shadow: inset 0 0 0 3px var(--c-cream);
}

.apf__section-label {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--c-ink);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--line);
  padding-bottom: var(--sp-3);
  margin: var(--sp-3) 0 0;
}

.apf__char-count {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
  margin-top: var(--sp-1);
}
.apf__char-count--warn {
  color: var(--accent);
}

/* ── Eligibility chapter ── */
.apf__elig {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.apf__elig-intro {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  background: rgba(27, 27, 27, 0.04);
  border-radius: var(--radius-sm);
  padding: var(--sp-4);
}
.apf__elig-icon {
  font-size: 1.2rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
}
.apf__elig-intro p {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  margin: 0;
  line-height: var(--lh-body);
}

.apf__elig-q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-5);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: var(--sp-5);
}
.apf__elig-q-text {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  flex: 1 1;
}
.apf__elig-q-text svg {
  font-size: 1rem;
  color: rgba(168, 102, 66, 0.65);
  flex-shrink: 0;
  margin-top: 2px;
}
.apf__elig-q-text p {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--c-ink);
  margin: 0;
  line-height: var(--lh-body);
}

.apf__elig-btns {
  display: flex;
  gap: var(--sp-2);
  flex-shrink: 0;
}
.apf__elig-btn {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.12em;
  padding: 0.5rem 1rem;
  border: 1.5px solid var(--line);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--c-ink);
  cursor: pointer;
  transition: all var(--dur) var(--ease);
}
.apf__elig-btn.yes {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}
.apf__elig-btn.no {
  background: var(--c-ink);
  border-color: var(--c-ink);
  color: var(--c-cream);
}
.apf__elig-btn:hover:not(.yes):not(.no) {
  border-color: var(--accent);
  color: var(--accent);
}

.apf__crisis {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-4);
  background: rgba(168, 102, 66, 0.08);
  border: 1px solid rgba(168, 102, 66, 0.3);
  border-radius: var(--radius-sm);
  padding: var(--sp-5);
}
.apf__crisis svg {
  font-size: 1.2rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
}
.apf__crisis-title {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  font-weight: 700;
  color: var(--c-ink);
  margin: 0 0 var(--sp-2);
}
.apf__crisis p {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0 0 var(--sp-3);
}
.apf__crisis-link {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--accent);
  text-decoration: none;
}

.apf__elig-ok {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  background: rgba(74, 94, 66, 0.08);
  border: 1px solid rgba(74, 94, 66, 0.25);
  border-radius: var(--radius-sm);
  padding: var(--sp-4);
}
.apf__elig-ok svg {
  color: #4a5e42;
  font-size: 1rem;
}
.apf__elig-ok p {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--c-ink);
  margin: 0;
}

/* ── Documents chapter ── */
.apf__docs {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}
.apf__docs-note {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}
.apf__docs-note a {
  color: var(--accent);
  text-decoration: none;
}

.apf__doc-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--sp-2, 8px);
  background: none;
  border: none;
  padding: 0;
  color: var(--accent);
  cursor: pointer;
  font-size: 0.95em;
  vertical-align: middle;
  line-height: 1;
}
.apf__doc-info-btn:hover,
.apf__doc-info-btn:focus-visible {
  opacity: 0.75;
}

.apf__doc-info-panel {
  overflow: hidden;
  background: var(--c-cream, #f7f4ef);
  border: 1px solid var(--border-subtle, #e4ddd0);
  border-radius: 10px;
  padding: var(--sp-4, 14px) var(--sp-5, 18px);
  margin-top: calc(-1 * var(--sp-2, 8px));
}
.apf__doc-info-title {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--c-ink);
  margin: 0 0 var(--sp-2, 8px);
}
.apf__doc-info-list {
  margin: 0;
  padding-left: 1.1em;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.apf__doc-info-list li {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
}

.apf__upload {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.apf__upload-label {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--c-ink);
  margin: 0;
}

.apf__dropzone {
  border: 1.5px dashed var(--line);
  border-radius: var(--radius);
  padding: clamp(1.5rem, 3vw, 2.5rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-3);
  cursor: pointer;
  transition:
    border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
  text-align: center;
}
.apf__dropzone:hover {
  border-color: var(--accent);
  background: rgba(168, 102, 66, 0.04);
}

.apf__file-input {
  display: none;
}

.apf__dropzone-icon {
  font-size: 2rem;
  color: var(--accent);
}
.apf__dropzone-text {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}
.apf__dropzone-text span {
  color: var(--accent);
  text-decoration: underline;
}

/* ── Review chapter ── */
.apf__review {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}
.apf__review-section {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  overflow: hidden;
}
.apf__review-head {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  background: rgba(27, 27, 27, 0.03);
  padding: var(--sp-4) var(--sp-5);
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--c-ink);
}
.apf__review-head svg {
  color: var(--accent);
  font-size: 1rem;
}
.apf__review-edit {
  margin-left: auto;
  background: none;
  border: none;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--accent);
  cursor: pointer;
  text-transform: uppercase;
}
.apf__review-edit:hover {
  color: var(--accent-hover);
}
.apf__review-fields {
  padding: var(--sp-4) var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.apf__review-field {
  display: flex;
  justify-content: space-between;
  gap: var(--sp-5);
}
.apf__review-key {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  text-transform: capitalize;
  color: var(--text-muted);
  flex-shrink: 0;
}
.apf__review-val {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--c-ink);
  font-weight: 600;
  text-align: right;
}

/* Checkboxes */
.apf__checks {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  margin-top: var(--sp-3);
}
.apf__check {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  cursor: pointer;
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--c-ink);
  line-height: var(--lh-body);
}
.apf__check input {
  display: none;
}
.apf__check-mark {
  width: 1.1rem;
  height: 1.1rem;
  border: 1.5px solid var(--line);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.55rem;
  color: transparent;
  transition: all var(--dur) var(--ease);
}
.apf__check--checked .apf__check-mark {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}
.apf__checks-warn {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--accent);
  margin: 0;
}

/* ── Navigation buttons ── */
.apf__nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: var(--sp-5);
  border-top: 1px solid var(--line);
  flex-wrap: wrap;
  gap: var(--sp-4);
}

.apf__nav-right {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
}

.apf__nav-save {
  background: none;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 0.9rem 1.5rem;
  cursor: pointer;
  transition:
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}
.apf__nav-save:hover {
  border-color: var(--c-ink);
  color: var(--c-ink);
}

.apf__nav-back {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  background: none;
  border: none;
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  transition: color var(--dur) var(--ease);
}
.apf__nav-back:hover {
  color: var(--c-ink);
}

.apf__nav-next {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-3);
  background: var(--accent);
  color: var(--on-accent);
  border: none;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-xs);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 1rem 2rem;
  border-radius: 0;
  cursor: pointer;
  transition:
    background var(--dur) var(--ease),
    gap var(--dur) var(--ease);
}
.apf__nav-next:hover:not(:disabled) {
  background: var(--accent-hover);
  gap: var(--sp-4);
}
.apf__nav-next:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Why We Ask box ── */
.apf__why {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-6);
  background: var(--surface);
  border-radius: var(--radius);
  padding: clamp(1.5rem, 3vw, 2.5rem);
}

.apf__why-img {
  width: clamp(250px, 16vw, 400px);
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
  opacity: 0.8;
}

.apf__why-content {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  flex: 1 1;
}

.apf__why-heading {
  color: var(--accent) !important;
  letter-spacing: var(--track-eyebrow);
}

.apf__why-rule {
  display: block;
  width: 1.5rem;
  height: 2px;
  background: var(--accent);
}

.apf__why-text {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}

.apf__why-points {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-5);
  margin-top: var(--sp-2);
}
.apf__why-point {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
.apf__why-point svg {
  font-size: 0.85rem;
  color: var(--accent);
  flex-shrink: 0;
}

/* ── Success screen — matches image 3 exactly ── */
.apf__success-wrap {
  padding-block: var(--section-y);
  background: var(--c-cream);
}

.apf__success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--sp-6);
  max-width: 42rem;
  margin-inline: auto;
  padding-inline: var(--gutter);
}

/* Badge */
.apf__success-badge .wws__badge {
  width: clamp(80px, 12vw, 110px) !important;
  height: clamp(80px, 12vw, 110px) !important;
}

/* Headline */
.apf__success-title {
  font-size: clamp(3rem, 9vw, 6rem);
  color: var(--c-forest);
  margin: 0;
  line-height: var(--lh-tight);
}

/* Rule row — — ⊕ — — */
.apf__success-rule-row {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  width: 100%;
  max-width: 14rem;
}
.apf__success-rule {
  flex: 1 1;
  height: 2px;
  background: var(--accent);
  opacity: 0.6;
  display: block;
}
.apf__success-mark {
  font-size: 1rem;
  color: var(--accent);
  flex-shrink: 0;
}

/* Subtitle */
.apf__success-sub {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}

/* Timeline — horizontal, dots + dashed connectors */
.apf__success-timeline {
  display: flex;
  align-items: flex-start;
  width: 100%;
  background: var(--surface);
  border-radius: var(--radius);
  padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 3vw, 2rem);
}

.apf__success-step {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}

/* Dashed line between steps */
.apf__success-line {
  flex: 1 1;
  height: 1.5px;
  border-top: 1.5px dashed rgba(27, 27, 27, 0.18);
  margin-bottom: clamp(1.2rem, 3vw, 1.5rem);
  min-width: 0.5rem;
}

.apf__success-dot-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-3);
  flex-shrink: 0;
}

.apf__success-dot {
  width: clamp(1.75rem, 4vw, 2.25rem);
  height: clamp(1.75rem, 4vw, 2.25rem);
  border-radius: 50%;
  border: 1.5px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  color: transparent;
  background: var(--c-cream);
  flex-shrink: 0;
}
.apf__success-dot--active {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}

.apf__success-step-label {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
  text-align: center;
  line-height: var(--lh-snug);
  max-width: 5rem;
}

/* Email icon + ETA */
.apf__success-eta-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-3);
}

.apf__success-email-icon {
  font-size: 2rem;
  color: var(--text-muted);
  opacity: 0.6;
}

.apf__success-eta {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}
.apf__success-eta strong {
  color: var(--accent);
}

/* CTA */
.apf__success-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-3);
  background: var(--accent);
  color: var(--on-accent);
  text-decoration: none;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-xs);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  padding: 1rem 2.5rem;
  transition: background var(--dur) var(--ease);
}
.apf__success-btn:hover {
  background: var(--accent-hover);
  color: var(--on-accent);
}

/* Mobile success screen */
@media (max-width: 767.98px) {
  .apf__success-title {
    font-size: clamp(2.6rem, 12vw, 4rem);
  }
  .apf__success-timeline {
    flex-direction: column;
    align-items: flex-start;
    padding: var(--sp-5);
    gap: 0;
  }
  .apf__success-step {
    flex-direction: column;
    align-items: flex-start;
    flex: none;
    width: 100%;
  }
  .apf__success-dot-wrap {
    flex-direction: row;
    align-items: center;
    gap: var(--sp-4);
    width: 100%;
    padding-block: var(--sp-3);
  }
  .apf__success-step-label {
    max-width: none;
    text-align: left;
    font-size: var(--fs-sm);
  }
  .apf__success-line {
    width: 1.5px;
    height: 1.25rem;
    border-top: none;
    border-left: 1.5px dashed rgba(27, 27, 27, 0.18);
    margin-bottom: 0;
    margin-left: calc(clamp(1.75rem, 4vw, 2.25rem) / 2);
    flex: none;
    min-width: auto;
  }
}

/* ── Footer quote band ── */
.apf__footer-band {
  background: var(--c-forest);
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: clamp(2rem, 5vw, 5rem);
  padding: clamp(1.5rem, 3vw, 2.5rem) clamp(1.5rem, 5vw, 4rem);
}

.apf__footer-quote p {
  font-family: var(--font-serif);
  font-style: italic;
  font-size: clamp(1rem, 1.8vw, 1.35rem);
  color: var(--c-sand);
  line-height: var(--lh-snug);
  margin: 0 0 var(--sp-2);
}
.apf__footer-quote cite {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.14em;
  color: var(--accent);
  font-style: normal;
}

.apf__footer-trust {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  max-width: 22rem;
}
.apf__footer-trust svg {
  font-size: 1rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
}
.apf__footer-trust p {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: rgba(220, 204, 180, 0.55);
  line-height: var(--lh-body);
  margin: 0;
}

.apf__footer-badge .wws__badge {
  width: 70px !important;
  height: 70px !important;
}

/* ── Responsive ── */
@media (max-width: 991.98px) {
  .apf__layout {
    grid-template-columns: 1fr;
  }

  .apf__sidebar {
    position: static;
    height: auto;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 0;
    padding: var(--sp-4) var(--sp-5);
  }
  .apf__sidebar-heading,
  .apf__sidebar-help,
  .apf__sidebar-badge {
    display: none;
  }

  .apf__sidebar-nav {
    flex-direction: row;
    gap: 0;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .apf__sidebar-nav::-webkit-scrollbar {
    display: none;
  }
  .apf__sidebar-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: var(--sp-3) var(--sp-4);
    min-width: 4rem;
  }
  .apf__sidebar-labels {
    display: none;
  }
  .apf__sidebar-connector {
    display: none;
  }

  .apf__why {
    flex-direction: column;
  }
  .apf__why-img {
    width: 180px;
  }

  .apf__footer-band {
    grid-template-columns: 1fr;
  }
  .apf__footer-badge {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .apf__row {
    grid-template-columns: 1fr;
  }
  .apf__elig-q {
    flex-direction: column;
    align-items: flex-start;
  }
  .apf__success-timeline {
    flex-direction: column;
    gap: var(--sp-5);
    align-items: flex-start;
    padding: var(--sp-5);
  }
  .apf__success-line {
    display: none;
  }
}

/* ── Save & Exit → Back to Review variant ── */
.apf__nav-save--review {
  border-color: var(--accent);
  color: var(--accent);
  font-weight: 700;
}
.apf__nav-save--review:hover {
  background: rgba(168, 102, 66, 0.06);
}

/* ── Chapter validation error ── */
.apf__chapter-error {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  background: rgba(220, 38, 38, 0.07);
  border: 1.5px solid rgba(220, 38, 38, 0.25);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.88rem;
  font-weight: 600;
  color: #dc2626;
  margin-bottom: 1rem;
  animation: apf-shake 0.35s ease;
}

@keyframes apf-shake {
  0%,
  100% {
    transform: translateX(0);
  }
  20%,
  60% {
    transform: translateX(-4px);
  }
  40%,
  80% {
    transform: translateX(4px);
  }
}

/* ══════════════════════════════════════════════════════
   INLINE FIELD VALIDATION STYLES
══════════════════════════════════════════════════════ */

/* Field wrapper — red left border when invalid */
.apf__field--error > .apf__label {
  color: #dc2626;
}
.apf__field--error > .apf__label .apf__req {
  color: #dc2626;
}

/* Red error message under the field */
.apf__field-error-msg {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #dc2626;
  margin: 0.25rem 0 0;
  animation: apf-shake 0.3s ease;
}
.apf__field-error-msg::before {
  content: "⚠";
  font-size: 0.7rem;
}

/* Red border on invalid inputs */
.apf__input--error,
.apf__input--error:focus {
  border-color: #dc2626 !important;
  background: rgba(220, 38, 38, 0.03);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;
}

/* Red border on invalid radio groups */
.apf__radios--error {
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border: 1.5px solid #dc2626;
  background: rgba(220, 38, 38, 0.03);
}

/* Eligibility question — error state */
.apf__elig-q--error {
  border-left: 3px solid #dc2626;
  padding-left: 1rem;
  background: rgba(220, 38, 38, 0.03);
  border-radius: 0 6px 6px 0;
}
.apf__elig-error {
  font-size: 0.78rem;
  font-weight: 600;
  color: #dc2626;
  margin: 0.4rem 0 0;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.apf__elig-error::before {
  content: "⚠";
  font-size: 0.7rem;
}

/* Error summary banner at top of chapter */
.apf__error-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  background: rgba(220, 38, 38, 0.07);
  border: 1.5px solid rgba(220, 38, 38, 0.28);
  border-radius: 10px;
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
  overflow: hidden;
}
.apf__error-banner-icon {
  font-size: 1rem;
  flex-shrink: 0;
  color: #dc2626;
  margin-top: 1px;
}
.apf__error-banner strong {
  display: block;
  font-size: 0.84rem;
  color: #dc2626;
  margin-bottom: 0.35rem;
}
.apf__error-list {
  margin: 0;
  padding: 0 0 0 1.1rem;
  list-style: disc;
}
.apf__error-list li {
  font-size: 0.8rem;
  color: #b91c1c;
  line-height: 1.5;
  margin-bottom: 0.15rem;
}

/* Shake animation on error */
@keyframes apf-shake {
  0%,
  100% {
    transform: translateX(0);
  }
  20%,
  60% {
    transform: translateX(-3px);
  }
  40%,
  80% {
    transform: translateX(3px);
  }
}

/* ── Banned / Duplicate error banners ── */
.apf__error-banner--banned {
  background: rgba(27,27,27,0.06);
  border: 1.5px solid rgba(27,27,27,0.22);
  color: #1b1b1b;
}
.apf__error-banner--duplicate {
  background: rgba(217,119,6,0.07);
  border: 1.5px solid rgba(217,119,6,0.28);
  color: #92400e;
}

/* Secondary link under the success button */
.apf__success-home {
  display: inline-block; margin-top: 0.9rem; font-size: 0.8rem; font-weight: 600;
  color: var(--c-muted, #6b6258); text-decoration: underline; text-underline-offset: 3px;
}
.apf__success-home:hover { color: var(--c-rust, #b85c38); }
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyForm.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;;gEAEgE;AAChE;EACE,2BAA2B;EAC3B,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd;;;gCAG8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;EACV,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;gEAEgE;AAChE;EACE,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb;;qCAEmC;EACnC,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd;;qCAEmC;EACnC,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,+CAA+C;EAC/C,mBAAmB;EACnB,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf;;qCAEmC;EACnC,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf;;gCAE8B;AAChC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;8BAE4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,aAAa;AACb;EACE,iCAAiC;EACjC,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,aAAa;EACb,+CAA+C;EAC/C,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;;AAEA,QAAQ;AACR;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE;IACE,oCAAoC;EACtC;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,MAAM;EACR;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gDAAgD;IAChD,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,gCAAgC;EAClC;EACA;;;IAGE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,MAAM;IACN,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;wDAEwD;;AAExD,iDAAiD;AACjD;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;;EAEE,gCAAgC;EAChC,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA,uCAAuC;AACvC;EACE,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,2CAA2C;AAC3C;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB;EAC9E,8BAA8B,EAAE,0BAA0B,EAAE,0BAA0B;AACxF;AACA,2BAA2B,6BAA6B,EAAE","sourcesContent":["/* ============================================================\n   ApplyForm — 8-chapter application wizard\n   Layout: dark sidebar (left) | cream form area (right)\n   ============================================================ */\n\n.apf {\n  background: var(--c-cream);\n  border-top: 1px solid var(--line);\n}\n\n/* ── Outer layout ── */\n.apf__layout {\n  display: grid;\n  grid-template-columns: clamp(200px, 22%, 280px) 1fr;\n  min-height: 100vh;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   SIDEBAR\n══════════════════════════════════════════════════════════════ */\n.apf__sidebar {\n  background: var(--c-forest);\n  padding: clamp(1.5rem, 3vw, 2.5rem) clamp(1rem, 2.5vw, 2rem);\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-6);\n  position: sticky;\n  top: 60px;\n  height: calc(100vh - 60px);\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.apf__sidebar::-webkit-scrollbar {\n  display: none;\n}\n\n.apf__sidebar-heading {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.45);\n  margin: 0;\n}\n\n/* Nav items */\n.apf__sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  position: relative;\n}\n\n.apf__sidebar-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: var(--sp-4) 0;\n  text-align: left;\n  position: relative;\n  transition: opacity var(--dur) var(--ease);\n}\n.apf__sidebar-item:not(.active):not(.done) {\n  opacity: 0.45;\n  cursor: default;\n}\n.apf__sidebar-item.active {\n  opacity: 1;\n}\n.apf__sidebar-item.done {\n  opacity: 0.75;\n  cursor: pointer;\n}\n.apf__sidebar-item.done:hover {\n  opacity: 1;\n}\n\n/* Number circle */\n.apf__sidebar-num {\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 50%;\n  border: 1.5px solid rgba(220, 204, 180, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  color: rgba(220, 204, 180, 0.55);\n  flex-shrink: 0;\n  transition:\n    background var(--dur) var(--ease),\n    border-color var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n\n.apf__sidebar-item.active .apf__sidebar-num {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--on-accent);\n}\n.apf__sidebar-item.done .apf__sidebar-num {\n  background: rgba(168, 102, 66, 0.25);\n  border-color: var(--accent);\n  color: var(--accent);\n  font-size: 0.6rem;\n}\n\n.apf__sidebar-labels {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.apf__sidebar-super {\n  font-family: var(--font-body);\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  color: rgba(220, 204, 180, 0.4);\n  line-height: 1;\n}\n.apf__sidebar-item.active .apf__sidebar-super {\n  color: var(--accent);\n}\n\n.apf__sidebar-sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: rgba(220, 204, 180, 0.75);\n  line-height: 1;\n}\n.apf__sidebar-item.active .apf__sidebar-sub {\n  color: var(--c-sand);\n  font-weight: 600;\n}\n\n/* Connector line between items */\n.apf__sidebar-connector {\n  position: absolute;\n  left: calc(1.75rem / 2);\n  top: calc(var(--sp-4) + 1.75rem);\n  width: 1px;\n  height: var(--sp-4);\n  background: rgba(220, 204, 180, 0.15);\n  transform: translateX(-50%);\n}\n\n/* Help box */\n.apf__sidebar-help {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  background: rgba(168, 102, 66, 0.12);\n  border: 1px solid rgba(168, 102, 66, 0.25);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-4);\n  margin-top: auto;\n}\n\n.apf__sidebar-help-icon {\n  font-size: 1.1rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.apf__sidebar-help-title {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  color: var(--c-sand);\n  margin: 0 0 0.1rem;\n}\n.apf__sidebar-help-sub {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  color: rgba(220, 204, 180, 0.5);\n  margin: 0 0 0.3rem;\n}\n.apf__sidebar-help-link {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  color: var(--accent);\n  text-decoration: none;\n}\n.apf__sidebar-help-link:hover {\n  color: var(--c-sand);\n}\n\n.apf__sidebar-badge {\n  display: flex;\n  justify-content: center;\n  padding-bottom: var(--sp-3);\n}\n.apf__sidebar-badge .wws__badge {\n  width: 70px !important;\n  height: 70px !important;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   MAIN FORM AREA\n══════════════════════════════════════════════════════════════ */\n.apf__main {\n  padding: clamp(2rem, 4vw, 4rem) clamp(1.5rem, 4vw, 3.5rem);\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.5rem, 3vw, 2.5rem);\n  max-width: 860px;\n}\n\n/* Chapter meta: label + progress */\n.apf__chapter-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--sp-4);\n}\n\n.apf__chapter-tag {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--accent);\n  border: 1px solid var(--accent);\n  padding: 0.3rem 0.8rem;\n  border-radius: var(--radius-sm);\n}\n\n.apf__progress-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.25rem;\n}\n.apf__progress-label {\n  font-family: var(--font-body);\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.apf__progress-pct {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  color: var(--accent);\n}\n\n.apf__progress-bar {\n  width: clamp(120px, 18vw, 220px);\n  height: 3px;\n  background: var(--line);\n  border-radius: 99px;\n  overflow: hidden;\n}\n.apf__progress-fill {\n  height: 100%;\n  background: var(--accent);\n  border-radius: 99px;\n  transition: width 0.5s var(--ease);\n}\n\n/* Chapter heading */\n.apf__chapter-head {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-3);\n}\n.apf__chapter-title {\n  font-size: var(--fs-display);\n  color: var(--c-forest);\n  margin: 0;\n}\n.apf__chapter-sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n  max-width: 44rem;\n}\n\n/* ── Form fields ── */\n.apf__chapter-body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-5);\n}\n\n.apf__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--sp-4);\n}\n\n.apf__field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-2);\n}\n.apf__field--half {\n  /* used inside .apf__row, no extra style needed */\n}\n\n.apf__label {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--c-ink);\n}\n.apf__req {\n  color: var(--accent);\n}\n\n.apf__input {\n  width: 100%;\n  border: 1px solid rgba(27, 27, 27, 0.22);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  padding: 0.85rem 1rem;\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  color: var(--c-ink);\n  outline: none;\n  transition:\n    border-color var(--dur) var(--ease),\n    box-shadow var(--dur) var(--ease);\n  appearance: none;\n  -webkit-appearance: none;\n}\n.apf__input::placeholder {\n  color: rgba(27, 27, 27, 0.35);\n}\n.apf__input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(168, 102, 66, 0.1);\n}\n\n.apf__textarea {\n  resize: vertical;\n  min-height: 120px;\n  line-height: var(--lh-body);\n}\n\n/* Select wrapper */\n.apf__select-wrap {\n  position: relative;\n}\n.apf__select {\n  padding-right: 2.5rem;\n  cursor: pointer;\n  background: transparent;\n}\n.apf__select-icon {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n/* Radio group */\n.apf__radios {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-3);\n}\n.apf__radio {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  color: var(--c-ink);\n  cursor: pointer;\n}\n.apf__radio input[type=\"radio\"] {\n  display: none;\n}\n.apf__radio-mark {\n  width: 1.1rem;\n  height: 1.1rem;\n  border: 1.5px solid var(--line);\n  border-radius: 50%;\n  flex-shrink: 0;\n  transition:\n    border-color var(--dur) var(--ease),\n    background var(--dur) var(--ease);\n  position: relative;\n}\n.apf__radio--active .apf__radio-mark {\n  border-color: var(--accent);\n  background: var(--accent);\n  box-shadow: inset 0 0 0 3px var(--c-cream);\n}\n\n.apf__section-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--c-ink);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  border-bottom: 1px solid var(--line);\n  padding-bottom: var(--sp-3);\n  margin: var(--sp-3) 0 0;\n}\n\n.apf__char-count {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  margin-top: var(--sp-1);\n}\n.apf__char-count--warn {\n  color: var(--accent);\n}\n\n/* ── Eligibility chapter ── */\n.apf__elig {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-5);\n}\n\n.apf__elig-intro {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  background: rgba(27, 27, 27, 0.04);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-4);\n}\n.apf__elig-icon {\n  font-size: 1.2rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.apf__elig-intro p {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  margin: 0;\n  line-height: var(--lh-body);\n}\n\n.apf__elig-q {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sp-5);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-5);\n}\n.apf__elig-q-text {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  flex: 1;\n}\n.apf__elig-q-text svg {\n  font-size: 1rem;\n  color: rgba(168, 102, 66, 0.65);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.apf__elig-q-text p {\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  color: var(--c-ink);\n  margin: 0;\n  line-height: var(--lh-body);\n}\n\n.apf__elig-btns {\n  display: flex;\n  gap: var(--sp-2);\n  flex-shrink: 0;\n}\n.apf__elig-btn {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  padding: 0.5rem 1rem;\n  border: 1.5px solid var(--line);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--c-ink);\n  cursor: pointer;\n  transition: all var(--dur) var(--ease);\n}\n.apf__elig-btn.yes {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--on-accent);\n}\n.apf__elig-btn.no {\n  background: var(--c-ink);\n  border-color: var(--c-ink);\n  color: var(--c-cream);\n}\n.apf__elig-btn:hover:not(.yes):not(.no) {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.apf__crisis {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-4);\n  background: rgba(168, 102, 66, 0.08);\n  border: 1px solid rgba(168, 102, 66, 0.3);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-5);\n}\n.apf__crisis svg {\n  font-size: 1.2rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.apf__crisis-title {\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  font-weight: 700;\n  color: var(--c-ink);\n  margin: 0 0 var(--sp-2);\n}\n.apf__crisis p {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0 0 var(--sp-3);\n}\n.apf__crisis-link {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--accent);\n  text-decoration: none;\n}\n\n.apf__elig-ok {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n  background: rgba(74, 94, 66, 0.08);\n  border: 1px solid rgba(74, 94, 66, 0.25);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-4);\n}\n.apf__elig-ok svg {\n  color: #4a5e42;\n  font-size: 1rem;\n}\n.apf__elig-ok p {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--c-ink);\n  margin: 0;\n}\n\n/* ── Documents chapter ── */\n.apf__docs {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-6);\n}\n.apf__docs-note {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n.apf__docs-note a {\n  color: var(--accent);\n  text-decoration: none;\n}\n\n.apf__doc-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: var(--sp-2, 8px);\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--accent);\n  cursor: pointer;\n  font-size: 0.95em;\n  vertical-align: middle;\n  line-height: 1;\n}\n.apf__doc-info-btn:hover,\n.apf__doc-info-btn:focus-visible {\n  opacity: 0.75;\n}\n\n.apf__doc-info-panel {\n  overflow: hidden;\n  background: var(--c-cream, #f7f4ef);\n  border: 1px solid var(--border-subtle, #e4ddd0);\n  border-radius: 10px;\n  padding: var(--sp-4, 14px) var(--sp-5, 18px);\n  margin-top: calc(-1 * var(--sp-2, 8px));\n}\n.apf__doc-info-title {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--c-ink);\n  margin: 0 0 var(--sp-2, 8px);\n}\n.apf__doc-info-list {\n  margin: 0;\n  padding-left: 1.1em;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.apf__doc-info-list li {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n}\n\n.apf__upload {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-3);\n}\n.apf__upload-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--c-ink);\n  margin: 0;\n}\n\n.apf__dropzone {\n  border: 1.5px dashed var(--line);\n  border-radius: var(--radius);\n  padding: clamp(1.5rem, 3vw, 2.5rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--sp-3);\n  cursor: pointer;\n  transition:\n    border-color var(--dur) var(--ease),\n    background var(--dur) var(--ease);\n  text-align: center;\n}\n.apf__dropzone:hover {\n  border-color: var(--accent);\n  background: rgba(168, 102, 66, 0.04);\n}\n\n.apf__file-input {\n  display: none;\n}\n\n.apf__dropzone-icon {\n  font-size: 2rem;\n  color: var(--accent);\n}\n.apf__dropzone-text {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  gap: var(--sp-2);\n}\n.apf__dropzone-text span {\n  color: var(--accent);\n  text-decoration: underline;\n}\n\n/* ── Review chapter ── */\n.apf__review {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-5);\n}\n.apf__review-section {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n.apf__review-head {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n  background: rgba(27, 27, 27, 0.03);\n  padding: var(--sp-4) var(--sp-5);\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--c-ink);\n}\n.apf__review-head svg {\n  color: var(--accent);\n  font-size: 1rem;\n}\n.apf__review-edit {\n  margin-left: auto;\n  background: none;\n  border: none;\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: var(--accent);\n  cursor: pointer;\n  text-transform: uppercase;\n}\n.apf__review-edit:hover {\n  color: var(--accent-hover);\n}\n.apf__review-fields {\n  padding: var(--sp-4) var(--sp-5);\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-3);\n}\n.apf__review-field {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--sp-5);\n}\n.apf__review-key {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  text-transform: capitalize;\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n.apf__review-val {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--c-ink);\n  font-weight: 600;\n  text-align: right;\n}\n\n/* Checkboxes */\n.apf__checks {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-4);\n  margin-top: var(--sp-3);\n}\n.apf__check {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  cursor: pointer;\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--c-ink);\n  line-height: var(--lh-body);\n}\n.apf__check input {\n  display: none;\n}\n.apf__check-mark {\n  width: 1.1rem;\n  height: 1.1rem;\n  border: 1.5px solid var(--line);\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n  margin-top: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.55rem;\n  color: transparent;\n  transition: all var(--dur) var(--ease);\n}\n.apf__check--checked .apf__check-mark {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--on-accent);\n}\n.apf__checks-warn {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--accent);\n  margin: 0;\n}\n\n/* ── Navigation buttons ── */\n.apf__nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: var(--sp-5);\n  border-top: 1px solid var(--line);\n  flex-wrap: wrap;\n  gap: var(--sp-4);\n}\n\n.apf__nav-right {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n}\n\n.apf__nav-save {\n  background: none;\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: 0.9rem 1.5rem;\n  cursor: pointer;\n  transition:\n    border-color var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n.apf__nav-save:hover {\n  border-color: var(--c-ink);\n  color: var(--c-ink);\n}\n\n.apf__nav-back {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-2);\n  background: none;\n  border: none;\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color var(--dur) var(--ease);\n}\n.apf__nav-back:hover {\n  color: var(--c-ink);\n}\n\n.apf__nav-next {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-3);\n  background: var(--accent);\n  color: var(--on-accent);\n  border: none;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-xs);\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  padding: 1rem 2rem;\n  border-radius: 0;\n  cursor: pointer;\n  transition:\n    background var(--dur) var(--ease),\n    gap var(--dur) var(--ease);\n}\n.apf__nav-next:hover:not(:disabled) {\n  background: var(--accent-hover);\n  gap: var(--sp-4);\n}\n.apf__nav-next:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Why We Ask box ── */\n.apf__why {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-6);\n  background: var(--surface);\n  border-radius: var(--radius);\n  padding: clamp(1.5rem, 3vw, 2.5rem);\n}\n\n.apf__why-img {\n  width: clamp(250px, 16vw, 400px);\n  height: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n.apf__why-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-3);\n  flex: 1;\n}\n\n.apf__why-heading {\n  color: var(--accent) !important;\n  letter-spacing: var(--track-eyebrow);\n}\n\n.apf__why-rule {\n  display: block;\n  width: 1.5rem;\n  height: 2px;\n  background: var(--accent);\n}\n\n.apf__why-text {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n.apf__why-points {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--sp-5);\n  margin-top: var(--sp-2);\n}\n.apf__why-point {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-2);\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n}\n.apf__why-point svg {\n  font-size: 0.85rem;\n  color: var(--accent);\n  flex-shrink: 0;\n}\n\n/* ── Success screen — matches image 3 exactly ── */\n.apf__success-wrap {\n  padding-block: var(--section-y);\n  background: var(--c-cream);\n}\n\n.apf__success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: var(--sp-6);\n  max-width: 42rem;\n  margin-inline: auto;\n  padding-inline: var(--gutter);\n}\n\n/* Badge */\n.apf__success-badge .wws__badge {\n  width: clamp(80px, 12vw, 110px) !important;\n  height: clamp(80px, 12vw, 110px) !important;\n}\n\n/* Headline */\n.apf__success-title {\n  font-size: clamp(3rem, 9vw, 6rem);\n  color: var(--c-forest);\n  margin: 0;\n  line-height: var(--lh-tight);\n}\n\n/* Rule row — — ⊕ — — */\n.apf__success-rule-row {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n  width: 100%;\n  max-width: 14rem;\n}\n.apf__success-rule {\n  flex: 1;\n  height: 2px;\n  background: var(--accent);\n  opacity: 0.6;\n  display: block;\n}\n.apf__success-mark {\n  font-size: 1rem;\n  color: var(--accent);\n  flex-shrink: 0;\n}\n\n/* Subtitle */\n.apf__success-sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n/* Timeline — horizontal, dots + dashed connectors */\n.apf__success-timeline {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  background: var(--surface);\n  border-radius: var(--radius);\n  padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 3vw, 2rem);\n}\n\n.apf__success-step {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Dashed line between steps */\n.apf__success-line {\n  flex: 1;\n  height: 1.5px;\n  border-top: 1.5px dashed rgba(27, 27, 27, 0.18);\n  margin-bottom: clamp(1.2rem, 3vw, 1.5rem);\n  min-width: 0.5rem;\n}\n\n.apf__success-dot-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--sp-3);\n  flex-shrink: 0;\n}\n\n.apf__success-dot {\n  width: clamp(1.75rem, 4vw, 2.25rem);\n  height: clamp(1.75rem, 4vw, 2.25rem);\n  border-radius: 50%;\n  border: 1.5px solid var(--line);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  color: transparent;\n  background: var(--c-cream);\n  flex-shrink: 0;\n}\n.apf__success-dot--active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--on-accent);\n}\n\n.apf__success-step-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  text-align: center;\n  line-height: var(--lh-snug);\n  max-width: 5rem;\n}\n\n/* Email icon + ETA */\n.apf__success-eta-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--sp-3);\n}\n\n.apf__success-email-icon {\n  font-size: 2rem;\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n.apf__success-eta {\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n.apf__success-eta strong {\n  color: var(--accent);\n}\n\n/* CTA */\n.apf__success-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-3);\n  background: var(--accent);\n  color: var(--on-accent);\n  text-decoration: none;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-xs);\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  padding: 1rem 2.5rem;\n  transition: background var(--dur) var(--ease);\n}\n.apf__success-btn:hover {\n  background: var(--accent-hover);\n  color: var(--on-accent);\n}\n\n/* Mobile success screen */\n@media (max-width: 767.98px) {\n  .apf__success-title {\n    font-size: clamp(2.6rem, 12vw, 4rem);\n  }\n  .apf__success-timeline {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: var(--sp-5);\n    gap: 0;\n  }\n  .apf__success-step {\n    flex-direction: column;\n    align-items: flex-start;\n    flex: none;\n    width: 100%;\n  }\n  .apf__success-dot-wrap {\n    flex-direction: row;\n    align-items: center;\n    gap: var(--sp-4);\n    width: 100%;\n    padding-block: var(--sp-3);\n  }\n  .apf__success-step-label {\n    max-width: none;\n    text-align: left;\n    font-size: var(--fs-sm);\n  }\n  .apf__success-line {\n    width: 1.5px;\n    height: 1.25rem;\n    border-top: none;\n    border-left: 1.5px dashed rgba(27, 27, 27, 0.18);\n    margin-bottom: 0;\n    margin-left: calc(clamp(1.75rem, 4vw, 2.25rem) / 2);\n    flex: none;\n    min-width: auto;\n  }\n}\n\n/* ── Footer quote band ── */\n.apf__footer-band {\n  background: var(--c-forest);\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: clamp(2rem, 5vw, 5rem);\n  padding: clamp(1.5rem, 3vw, 2.5rem) clamp(1.5rem, 5vw, 4rem);\n}\n\n.apf__footer-quote p {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-size: clamp(1rem, 1.8vw, 1.35rem);\n  color: var(--c-sand);\n  line-height: var(--lh-snug);\n  margin: 0 0 var(--sp-2);\n}\n.apf__footer-quote cite {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  color: var(--accent);\n  font-style: normal;\n}\n\n.apf__footer-trust {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  max-width: 22rem;\n}\n.apf__footer-trust svg {\n  font-size: 1rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.apf__footer-trust p {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: rgba(220, 204, 180, 0.55);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n.apf__footer-badge .wws__badge {\n  width: 70px !important;\n  height: 70px !important;\n}\n\n/* ── Responsive ── */\n@media (max-width: 991.98px) {\n  .apf__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .apf__sidebar {\n    position: static;\n    height: auto;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    gap: 0;\n    padding: var(--sp-4) var(--sp-5);\n  }\n  .apf__sidebar-heading,\n  .apf__sidebar-help,\n  .apf__sidebar-badge {\n    display: none;\n  }\n\n  .apf__sidebar-nav {\n    flex-direction: row;\n    gap: 0;\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n  .apf__sidebar-nav::-webkit-scrollbar {\n    display: none;\n  }\n  .apf__sidebar-item {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: var(--sp-3) var(--sp-4);\n    min-width: 4rem;\n  }\n  .apf__sidebar-labels {\n    display: none;\n  }\n  .apf__sidebar-connector {\n    display: none;\n  }\n\n  .apf__why {\n    flex-direction: column;\n  }\n  .apf__why-img {\n    width: 180px;\n  }\n\n  .apf__footer-band {\n    grid-template-columns: 1fr;\n  }\n  .apf__footer-badge {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .apf__row {\n    grid-template-columns: 1fr;\n  }\n  .apf__elig-q {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .apf__success-timeline {\n    flex-direction: column;\n    gap: var(--sp-5);\n    align-items: flex-start;\n    padding: var(--sp-5);\n  }\n  .apf__success-line {\n    display: none;\n  }\n}\n\n/* ── Save & Exit → Back to Review variant ── */\n.apf__nav-save--review {\n  border-color: var(--accent);\n  color: var(--accent);\n  font-weight: 700;\n}\n.apf__nav-save--review:hover {\n  background: rgba(168, 102, 66, 0.06);\n}\n\n/* ── Chapter validation error ── */\n.apf__chapter-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  background: rgba(220, 38, 38, 0.07);\n  border: 1.5px solid rgba(220, 38, 38, 0.25);\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #dc2626;\n  margin-bottom: 1rem;\n  animation: apf-shake 0.35s ease;\n}\n\n@keyframes apf-shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20%,\n  60% {\n    transform: translateX(-4px);\n  }\n  40%,\n  80% {\n    transform: translateX(4px);\n  }\n}\n\n/* ══════════════════════════════════════════════════════\n   INLINE FIELD VALIDATION STYLES\n══════════════════════════════════════════════════════ */\n\n/* Field wrapper — red left border when invalid */\n.apf__field--error > .apf__label {\n  color: #dc2626;\n}\n.apf__field--error > .apf__label .apf__req {\n  color: #dc2626;\n}\n\n/* Red error message under the field */\n.apf__field-error-msg {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #dc2626;\n  margin: 0.25rem 0 0;\n  animation: apf-shake 0.3s ease;\n}\n.apf__field-error-msg::before {\n  content: \"⚠\";\n  font-size: 0.7rem;\n}\n\n/* Red border on invalid inputs */\n.apf__input--error,\n.apf__input--error:focus {\n  border-color: #dc2626 !important;\n  background: rgba(220, 38, 38, 0.03);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;\n}\n\n/* Red border on invalid radio groups */\n.apf__radios--error {\n  padding: 0.65rem 0.75rem;\n  border-radius: 8px;\n  border: 1.5px solid #dc2626;\n  background: rgba(220, 38, 38, 0.03);\n}\n\n/* Eligibility question — error state */\n.apf__elig-q--error {\n  border-left: 3px solid #dc2626;\n  padding-left: 1rem;\n  background: rgba(220, 38, 38, 0.03);\n  border-radius: 0 6px 6px 0;\n}\n.apf__elig-error {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #dc2626;\n  margin: 0.4rem 0 0;\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n.apf__elig-error::before {\n  content: \"⚠\";\n  font-size: 0.7rem;\n}\n\n/* Error summary banner at top of chapter */\n.apf__error-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  background: rgba(220, 38, 38, 0.07);\n  border: 1.5px solid rgba(220, 38, 38, 0.28);\n  border-radius: 10px;\n  padding: 0.85rem 1rem;\n  margin-bottom: 1.25rem;\n  overflow: hidden;\n}\n.apf__error-banner-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n  color: #dc2626;\n  margin-top: 1px;\n}\n.apf__error-banner strong {\n  display: block;\n  font-size: 0.84rem;\n  color: #dc2626;\n  margin-bottom: 0.35rem;\n}\n.apf__error-list {\n  margin: 0;\n  padding: 0 0 0 1.1rem;\n  list-style: disc;\n}\n.apf__error-list li {\n  font-size: 0.8rem;\n  color: #b91c1c;\n  line-height: 1.5;\n  margin-bottom: 0.15rem;\n}\n\n/* Shake animation on error */\n@keyframes apf-shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20%,\n  60% {\n    transform: translateX(-3px);\n  }\n  40%,\n  80% {\n    transform: translateX(3px);\n  }\n}\n\n/* ── Banned / Duplicate error banners ── */\n.apf__error-banner--banned {\n  background: rgba(27,27,27,0.06);\n  border: 1.5px solid rgba(27,27,27,0.22);\n  color: #1b1b1b;\n}\n.apf__error-banner--duplicate {\n  background: rgba(217,119,6,0.07);\n  border: 1.5px solid rgba(217,119,6,0.28);\n  color: #92400e;\n}\n\n/* Secondary link under the success button */\n.apf__success-home {\n  display: inline-block; margin-top: 0.9rem; font-size: 0.8rem; font-weight: 600;\n  color: var(--c-muted, #6b6258); text-decoration: underline; text-underline-offset: 3px;\n}\n.apf__success-home:hover { color: var(--c-rust, #b85c38); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
